/* eslint-disable import/no-duplicates */
import baseEditForm from 'formiojs/components/_classes/component/Component.form';
import SelectEditData from 'formiojs/components/select/editForm/Select.edit.data';
import SelectEditDisplay from 'formiojs/components/select/editForm/Select.edit.display';
import SelectEditValidation from 'formiojs/components/select/editForm/Select.edit.validation';

export default (...extend) => baseEditForm(
  [
    {
      key: 'display',
      components: SelectEditDisplay,
    },
    {
      key: 'data',
      components: SelectEditData,
    },
    {
      key: 'validation',
      components: SelectEditValidation,
    },
    {
      key: 'addons',
      ignore: true,
    },
    {
      label: 'Custom',
      key: 'custom',
      components: [
        {
          weight: 50,
          type: 'checkbox',
          label: 'Hide Custom Label',
          tooltip:
              'Hide the label (title, if no label) of this component. This allows you to show/hide the custom label when it is rendered.',
          key: 'hideCustomLabel',
          input: true,
        },
        {
          weight: 100,
          type: 'textfield',
          label: 'Session Storage Variable',
          tooltip: 'Variable used to update the value of the dropdown when the session storage is updated',
          key: 'sessionStorageVariable',
          input: true,
        },
        {
          weight: 150,
          type: 'checkbox',
          label: 'Use Session Storage',
          key: 'useSessionStorage',
          input: true,
        },
      ],
    },
    {
      label: 'Review',
      key: 'review',
      components: [
        {
          weight: 50,
          type: 'checkbox',
          label: 'Use Custom Label',
          tooltip: 'Use custom label for this component on the review page.',
          key: 'useReviewLabel',
          input: true,
        },
        {
          weight: 100,
          type: 'textfield',
          label: 'Review Page Label',
          key: 'reviewLabel',
          input: true,
        },
        {
          weight: 100,
          type: 'textfield',
          label: 'Review value (objects)',
          tooltip: 'Value to use in review when value is object.',
          key: 'reviewObjValue',
          input: true,
        },
      ],
    },
  ],
  ...extend,
);
